import {send} from 'ajax';
import {createDropIn} from 'bt_drop_in';
import {recalcPromo, clearPromo, applyPromo, togglePromo, prefilledPromo} from 'promocode';
import {user_has_more_then_one_order, checkout_user_email, checkout_edit_token} from 'run_payment';
import {fb_track_lead} from 'third_party_custom_callbacks';
import {fromDesktop} from 'hit';
import {getCookie} from 'browser';
import Mailcheck from 'mailcheck';

// go to second step if from desktop homepage
  if (fromDesktop) {
    window.scrollTo(0,0); 
    replaceDiv('step-0','step-1');
  }

/*setTimeout(function(){console.log('going for it'); document.getElementById('title_header_mobile_line1').classList.add('line1-out');}, 2000);
setTimeout(function(){console.log('going for it'); document.getElementById('step-1').classList.add('become-visible');}, 2000);
setTimeout(function(){console.log('going for it'); document.getElementById('step-1').classList.remove('currently-faded');}, 2000);
setTimeout(function(){console.log('going for it'); document.getElementById('step-1').classList.add('move');}, 2000);*/
var tel1 = document.getElementById('tel_area');
var tel2 = document.getElementById('tel_first');
var tel3 = document.getElementById('tel_second');
var splitTel = document.getElementById('split_tel');
var c_name = document.getElementById('child_name');
var email = document.getElementById('ordering_email');
    
var is_signup = window.location.pathname.includes('signup') || document.getElementById('homepage');

const promocode_checkbox = document.getElementById('giftcode');
const promocode_apply = document.getElementById('apply_promo_button');
const promocode_clear = document.getElementById('clear_promo_link');

const utm_source = document.getElementById('utm_source') ? document.getElementById('utm_source').innerHTML : '';


createDropIn();

if (document.getElementById("discount-close")) {
  document.getElementById("discount-close").addEventListener('click', (event) => {document.getElementById('discount-popup').classList.add('hidden');});
  document.getElementById("discount-button").addEventListener('click', (event) => { 
  // submit discount email
    send_discount();
  });
  document.getElementById("discount-confirm-close").addEventListener('click', (event) => {document.getElementById('discount-popup-confirm').classList.add('hidden');});
}

async function send_discount(){
  let discount_string = "email=" + document.getElementById('discountEmail').value;
  const d = await send("POST", "/api/discount_email", discount_string);
  document.getElementById('discount-popup').classList.add('hidden');
  document.getElementById('discount-popup-confirm').classList.remove('hidden');
}

if (is_signup) {
  promocode_checkbox.addEventListener('change', (event) => {togglePromo()});
  promocode_apply.addEventListener('click', (event) => {applyPromo(); 
     document.getElementById('title_header_mobile_line5').classList.add('hidden');
     document.getElementById('title_header_mobile_line6').classList.add('promo');
   } );
  promocode_clear.addEventListener('click', (event) => {clearPromo()});
  
  hide_recaptcha() // hide recaptcha if applicable 


  //ab_test_update(); // ab price test turned off: price comes from Configurable.package_baseline_p_type
  //get_ab_test_value();  // ab display test 
}

if (is_signup && document.getElementById('submit-payment_button')) {
 document.getElementById('submit-payment_button').addEventListener('click', function() {
   trackStep('checkout_tap');
   window.location.hash ='#step-4';
   document.getElementById('processing').classList.remove('hidden');
 });
}

// One phone field (autofill-friendly) fills the three hidden parts the rest of the flow uses.
var phone_full = document.getElementById('phone_full');
if (phone_full) {
  phone_full.addEventListener('input', (event) => { phone_full.classList.remove('error'); document.getElementById('bad-number').classList.add('hidden'); });
}

function splitPhone() {
  var digits = (phone_full ? phone_full.value : '').replace(/\D/g, '');
  if (digits.length == 11 && digits.charAt(0) == '1') { digits = digits.substring(1); }
  if (digits.length != 10) { return false; }
  tel1.value = digits.substring(0, 3);
  tel2.value = digits.substring(3, 6);
  tel3.value = digits.substring(6, 10);
  return true;
}

function showPhoneError() {
  phone_full.classList.add('error');
  document.getElementById('bad-number').classList.remove('hidden');
  window.scrollTo(0, 0);
}

if (email) {
  email.addEventListener('click', (event) => { email.classList.remove('error');}  );
}

// Landing test: half of visitors (kept per browser) get the child's name field and
// the trust lines (years, children, press, St. Jude) on the landing screen, so the
// first tap is a real step. Judge it on leads (reached payment) as well as paid:
// the price stays after the email step because the free trial converts those leads.
// The group is saved on the order (ab_test_2) and in step hits.
// (The earlier price-on-landing test lost: about half the new leads, no more buyers.)
var landing_test = 'a';
try {
  landing_test = localStorage.getItem('tfs_landing_test') || (Math.random() < 0.5 ? 'a' : 'b');
  localStorage.setItem('tfs_landing_test', landing_test);
} catch (err) { landing_test = Math.random() < 0.5 ? 'a' : 'b'; }
// Desktop visitors start on the desktop homepage (redirected by hit.js) and never
// see this landing screen, so keep them out of both groups.
if (fromDesktop || window.innerWidth > 900) { landing_test = 'desktop'; }
var landing_name = document.getElementById('landing_child_name');
if (landing_test == 'b' && landing_name) {
  document.getElementById('step-0').classList.add('landing-b');
}

// Step tracking: one hit per screen reached, so drop-off can be seen per step.
export function trackStep(step) {
  try {
    fetch('/santa/hit?path=' + encodeURIComponent('signup_' + step + '_landing_' + landing_test), { credentials: 'same-origin', keepalive: true });
  } catch (err) { console.log('step tracking: ' + err); }
}
// Opened from the Gmail confirmation email (see startConfirmLink): not a new visit.
var confirmLink = new URLSearchParams(window.location.search).get('confirm');
if (document.getElementById('step-0-next') && !confirmLink) { trackStep('landing'); }
window.tfsTrackStep = trackStep;

let step0 = document.getElementById('step-0-next');
if (step0) {
  step0.addEventListener('click', (event) => {
    window.scrollTo(0,0);
    trackStep('child_name');
    if (landing_test == 'b' && landing_name) {
      // The name was asked on the landing screen: go straight to phone and email.
      c_name.value = landing_name.value.trim();
      showContactStep('step-0');
    } else {
      replaceDiv('step-0','step-1');
    }
  });
}
if (landing_name) {
  landing_name.addEventListener('keydown', (event) => { if (event.key == 'Enter') { step0.click(); } });
}


let step1Next = document.getElementById('step-1-next');
if (step1Next) {
  step1Next.addEventListener('click', (event) => {
     window.scrollTo(0, 0);
     showContactStep('step-1');
  }  );
}

function showContactStep(fromStep) {
  document.getElementById('title_header_mobile_line3').textContent = c_name.value.length > 0 ? "Santa can't wait to show " + c_name.value + " the North Pole!" : "That's OK!  Santa can tell stories without using their name!";
  trackStep('contact');
  replaceDiv(fromStep, 'step-2');
}

let step2Next = document.getElementById('step-2-next');
if (step2Next) {
  createStep2Button(step2Next);
}

// One sign-up request at a time: a double tap used to make two orders.
var leadPending = false;
function createStep2Button(el) {
  el.addEventListener('click', (event) => { 
     if (leadPending) { return; }
     var phone_ok = splitPhone();
     var email_ok = email && email.value.includes("@") && email.value.includes('.');
     if (!phone_ok) { showPhoneError(); }
     if (!email_ok) { email.classList.add('error'); }
     if (phone_ok && email_ok) {
       document.getElementById('form_ordering_email').value = email.value;
       document.getElementById('discountEmail').value = email.value;
       leadPending = true;
       send_test_text(email.value, c_name.value, tel1, tel2, tel3).finally(() => { leadPending = false; });
     }
  }  );
}

let step5Next = document.getElementById('step-5-next');
if (step5Next) {
  step5Next.addEventListener('click', (event) => { 
       update_order();
       window.scrollTo(0, 0);
       document.getElementById('completed-order').innerHTML = (c_name.value || 'Your child') + ' is all set!';
       replaceDiv('step-5','step-6');
  }  );
}

let step6Next = document.getElementById('step-6-next');
if (step6Next) {
  step6Next.addEventListener('click', (event) => { 
    navigate_to_account();
  });
}

async function hide_recaptcha() {
    const useRecaptcha = await send('GET', '/santa/use_recaptcha');
    var use = useRecaptcha.result;
    /* if (use.toString() == '0') {
      document.getElementById('recaptcha_div').classList.add('hidden');
      document.getElementById('submit-payment_button').classList.remove('hidden');
    }*/
    // v3 is invisible
    document.getElementById('submit-payment_button').classList.remove('hidden');
}

function navigate_to_account() {
    console.log('user_has_more_then_one_order', user_has_more_then_one_order);
    if (user_has_more_then_one_order) {
      document.getElementById('ordering_email').value = checkout_user_email;
      document.getElementById('send_confirm_me_form').submit(); 
    } 
    else {
      Turbolinks.visit('/accounts/menu');
    }
}

async function update_order() {
  try { 
    let data_string = "token=" + encodeURIComponent(checkout_edit_token) + '&gender=' + document.getElementById('gender').value + '&town=' + document.getElementById('town').value + '&age=' + document.getElementById('age').value + '&pet_type=' + document.getElementById('pet_kind').value + '&pet_name=' + document.getElementById('pet_name').value + '&elf=' + document.getElementById('elf').value;
    console.log('data_string', data_string);
    const data = await send("POST", "/api/internal_ad_lead_update", data_string);
    if (data.status == 'success'){
      console.log('update success');
    }
    else {
      console.log('update failure');
    }
  }
  catch (err) {
    console.log('error saving order extra info: ' + err);
  }
}

async function send_test_text(email, c_name, tel1, tel2, tel3) {
      console.log('received ' + email + ' ' + c_name + 'edit' );
       try { 

        const data_ = {
          email: email,
          childs_name: c_name,
          phone_number: '1'+ tel1.value + tel2.value + tel3.value,
          site: 'ab_test_anime',
          sub: document.getElementById('sub').innerHTML,
          ab_test_value: document.getElementById('ab_test_value').innerHTML,
          utm_source: utm_source,
          utm_campaign: document.getElementById('utm_campaign') ? document.getElementById('utm_campaign').innerHTML : '',
          ab_test_2: 'landing_' + landing_test,
          fbc: getCookie('_fbc')
        }
         let data_string = new URLSearchParams(data_).toString();
         console.log('data_string', data_string);
         console.log('sending fb lead');
         fb_track_lead(email, true);
         console.log('jen testing')
         const data = await send("POST", "/api/internal_ad_lead", data_string);
          if (data.order_id == 0){
            let err_mes = 'Error with Sign Up - Please Try Again';
            Turbolinks.visit('/santa/signup?message=' + err_mes); 
          }
          else {
            document.getElementById('order_id').innerHTML = data.order_id;
          }
          if (data.err_message == 'invalid phone number'){
            console.log('invalid phone number')
            window.scrollTo(0, 0);
            showPhoneError();
          }
          if (data.err_message == 'none'){
            window.scrollTo(0, 0);
            document.getElementById('title_header_mobile_line5').innerHTML = c_name.length > 0 ? "Santa just sent a text to " + c_name + " with a picture from the North Pole!" : "Santa just sent a text with a picture from the North Pole!"; // this is hidden and currently turned off

            //const this_ab = document.getElementById('ab_assigned').innerHTML;
            //if (this_ab == 'b') { 
            //  Turbolinks.visit('/santa/text_packages?token=' + data.token); 
            // }
            //else {
            if (data.confirm) {
              showConfirmGate(data.confirm);
            } else {
              showPayment('step-2');
            }
            //}
          } 
          else {
            document.getElementById('title_header_mobile_line5').innerHTML = 'Santa had a problem sending the text to the number provided'; 
          }
        } 
        catch (err) {
          console.log('error sending anime text: ' + err);
        }
}

function showPayment(fromStep) {
  if (c_name.value.length > 0) {
    document.getElementById('title_header_mobile_line6').textContent = "Santa can't wait to text " + c_name.value + "!";
  }
  trackStep('payment');
  replaceDiv(fromStep, 'step-4');
  if (prefilledPromo()) { applyPromo(); }
}

// Gmail confirm test (see EmailConfirmation): a new Gmail sign-up in the test
// group finds our email (pulling it out of spam if needed) and taps its button
// before paying. This screen moves on by itself once they have, and after a
// minute offers a way past for anyone who can't find it.
const GATE_SKIP_AFTER_MS = 60 * 1000;
const GATE_CHECK_MS = 3000;
const GATE_CHECK_FOR_MS = 30 * 60 * 1000;
var confirmToken = null;
var gateTimer = null;
var gateSkipTimer = null;

function childOr(fallback) {
  return c_name.value.trim() || fallback;
}

function showConfirmGate(token) {
  confirmToken = token;
  document.getElementById('gate-title').textContent = "✨ Santa's elves are writing " + childOr('your child') + ' into the good list! ✨';
  document.getElementById('gate-email').textContent = email.value.trim();
  document.getElementById('gate-ask').textContent = 'Everyone knows Santa is real. Now the elves need to know you are too! Open it and tap the red button.';
  var skip = document.getElementById('gate-skip');
  skip.textContent = "Can't find it? Continue to " + (c_name.value.trim() ? c_name.value.trim() + "'s" : 'your') + ' spot';
  skip.classList.add('hidden');
  trackStep('confirm_gate');
  swapStep('step-2', 'step-3');
  var started = Date.now();
  clearInterval(gateTimer);
  clearTimeout(gateSkipTimer);
  gateTimer = setInterval(() => {
    if (Date.now() - started > GATE_CHECK_FOR_MS) { clearInterval(gateTimer); return; }
    checkGate();
  }, GATE_CHECK_MS);
  gateSkipTimer = setTimeout(() => { skip.classList.remove('hidden'); }, GATE_SKIP_AFTER_MS);
}

function gateShowing() {
  var gate = document.getElementById('step-3');
  return gate && gate.classList.contains('become-visible') && !gate.classList.contains('become-hidden');
}

async function checkGate() {
  if (!confirmToken || !gateShowing()) { return; }
  try {
    const r = await fetch('/santa/email_confirmed?token=' + encodeURIComponent(confirmToken), { credentials: 'same-origin', cache: 'no-store' });
    const d = r.ok ? await r.json() : null;
    if (d && d.confirmed && gateShowing()) {
      trackStep('confirm_done');
      passGate();
    }
  } catch (err) { console.log('confirm check: ' + err); }
}

function passGate() {
  clearInterval(gateTimer);
  clearTimeout(gateSkipTimer);
  showPayment('step-3');
}

// Back from their mail app: check straight away instead of waiting for the timer.
document.addEventListener('visibilitychange', () => { if (!document.hidden) { checkGate(); } });

var gateSkip = document.getElementById('gate-skip');
if (gateSkip) {
  gateSkip.addEventListener('click', () => { trackStep('confirm_skip'); passGate(); });
}
// A mistyped address is a new one, so it gets its own email after Next.
var gateFix = document.getElementById('gate-fix');
if (gateFix) {
  gateFix.addEventListener('click', () => {
    trackStep('confirm_fix');
    clearInterval(gateTimer);
    clearTimeout(gateSkipTimer);
    confirmToken = null;
    swapStep('step-3', 'step-2');
    email.focus();
  });
}

// Like replaceDiv, but keeps the Next button so the parent can come back to fix their email.
function swapStep(toGo, toShow) {
  document.getElementById(toGo).classList.remove('become-visible');
  document.getElementById(toGo).classList.add('become-hidden');
  document.getElementById(toShow).classList.remove('become-hidden', 'currently-faded');
  document.getElementById(toShow).classList.add('become-visible');
  window.scrollTo(0, 0);
}

// Steps are shown one at a time in normal page flow (see the end of anime.css).
export function replaceDiv(toGo, toShow){
  document.getElementById(toGo).classList.add('become-hidden');
  document.getElementById(toShow).classList.add('become-visible');
  document.getElementById(toShow).classList.remove('currently-faded');
  window.scrollTo(0, 0);
  var div_button = document.getElementById(toGo + '-next');
  if (div_button) {
    div_button.parentNode.removeChild(div_button);
  }
}

/////   upgrade buttons

var package1 = document.getElementById('package-one-button');
var package2 = document.getElementById('package-two-button');
var radioPackage1 = document.getElementById('radio-package-one');
var radioPackage2 = document.getElementById('radio-package-two');

if (package1) { // ok we are on that page
  package1.addEventListener('click', function() {
    package2.classList.remove('selected');
    package1.classList.add('selected');
    radioPackage1.checked = true;
    radioPackage2.checked = false;
  });
  package2.addEventListener('click', function() {
    package1.classList.remove('selected');
    package2.classList.add('selected');
    radioPackage2.checked = true;
    radioPackage1.checked = false;
  });
}

let upgradeStep = document.getElementById('step-addon-next');
if (upgradeStep) {
  upgradeStep.addEventListener('click', (event) => { 
    upgradeOrder();
  });
}

let finalStep = document.getElementById('no-thanks');
if (finalStep) {
  finalStep.addEventListener('click', (event) => { 
    navigate_to_account();
  });
}

async function upgradeOrder() {
  try { 

    let ab_val = document.getElementById('ab_assigned').innerHTML; 
    document.getElementById('step-addon-next').classList.add('hidden');
    document.getElementById('no-thanks').classList.add('hidden');
    document.getElementById('processing2').classList.remove('hidden');
    let package_name = document.getElementById('radio-package-two').checked ? 'video' : 'family';
    let data_string = "token=" + encodeURIComponent(checkout_edit_token) + '&package=' + package_name + '&ab=' + ab_val;
    console.log('data_string', data_string);
    const data = await send("POST", "/api/internal_package_upgrade", data_string);
    if (data.status == 'success'){
      console.log('update success');
    }
    else {
      console.log('update failure');
    }
    navigate_to_account();
  }
  catch (err) {
    console.log('error saving order extra info: ' + err);
    navigate_to_account();
  }
}


// This is base call to get ab test value of 'a' or 'b'
// Use this for other ab test functions
async function get_ab_test_value() {
  try {
    // A B price testing
    var ab_queryString = window.location.search;
    var ab_urlParams = new URLSearchParams(ab_queryString);
    const ab_test = await send('GET', '/santa/check_ab_testing?' + ab_urlParams);
    var ab_ = ab_test.result;
    document.getElementById('ab_test_value').innerHTML = ab_test.result_string; 
    document.getElementById('ab_assigned').innerHTML = ab_; 
    console.log('ab test value for this guy is ', ab_);

    //  Put ab frontend code changes here?
    // if (ab_ == 'b')

    return ab_;
  }
  catch (err) {
    console.log('error with ab test update: ' + err);
  }
}

async function ab_test_update() {
  try {
    // A B price testing
    var ab_queryString = window.location.search;
    var ab_urlParams = new URLSearchParams(ab_queryString);
    const ab_test = await send('GET', '/santa/check_ab_testing?' + ab_urlParams);
    var ab_ = ab_test.result;

    console.log('ab test value for this guy is ', ab_);
    document.getElementById('ab_assigned').innerHTML = ab_; 

    document.getElementById('title_header_mobile_line7').innerHTML = '<b>$29.95</b> for the year including:';
    document.getElementById('fc_p').innerHTML = 29.95;
    document.getElementById('fc').innerHTML = 29.95; 
    document.getElementById('package_cost').innerHTML = 29.95; 
    document.getElementById('c_selected_package').innerHTML = 26;
    document.getElementById('ab_test_value').innerHTML = ab_test.result_string; 

    /*if (ab_ == 'b') {
    }
    else {
    }*/
    // End of A B price testing
  }
  catch (err) {
    console.log('error with ab test update: ' + err);
  }
}


document.addEventListener('DOMContentLoaded', function() {
  var emailInput = document.getElementById('ordering_email');
  var suggestionDiv = document.getElementById('email-suggestion');
  
  if (emailInput) {
    emailInput.addEventListener('blur', function() {
      Mailcheck.run({
        email: emailInput.value,
        suggested: function(suggestion) {
          suggestionDiv.innerHTML = 
            'Did you mean <strong>' + suggestion.full + '</strong>? ' +
            '<a href="#" id="use-suggestion">Use this</a>';
          
          document.getElementById('use-suggestion').addEventListener('click', function(e) {
            e.preventDefault();
            emailInput.value = suggestion.full;
            suggestionDiv.innerHTML = '';
          });
        },
        empty: function() {
          suggestionDiv.innerHTML = '';
        }
      });
    });
  }
});

// Returning-customer link (?rejoin=<signed token> from the win-back email): fill the
// form from the family's last order and open the contact step, so they only check
// their details, tap Next and pay (the promo in the link is applied at checkout).
// Computers open these links with ?home=yes (see hit.js), which starts on the name step.
function openingStep() {
  return fromDesktop ? 'step-1' : 'step-0';
}

function startRejoin() {
  var token = new URLSearchParams(window.location.search).get('rejoin');
  if (!token || !phone_full) { return; }
  fetch('/santa/rejoin_prefill?token=' + encodeURIComponent(token), { credentials: 'same-origin' })
    .then((r) => (r.ok ? r.json() : null))
    .then((d) => {
      if (!d || !d.ok) { return; }
      document.querySelectorAll('#child_name').forEach((el) => { el.value = d.child_name || ''; });
      phone_full.value = d.phone || '';
      if (email) { email.value = d.email || ''; }
      document.getElementById('title_header_mobile_line3').textContent = d.child_name ?
        "Welcome back! Santa can't wait to text " + d.child_name + "!" : 'Welcome back to the North Pole!';
      trackStep('rejoin_contact');
      replaceDiv(openingStep(), 'step-2');
    })
    .catch((err) => console.log('rejoin prefill: ' + err));
}
startRejoin();

// The button in the Gmail confirmation email (?confirm=<token>) often opens in
// another browser than the sign-up, so the order comes from the server: confirm
// the address and open the payment step. Facebook's click
// id from the sign-up browser comes along so the purchase is still credited to the ad.
function startConfirmLink() {
  if (!confirmLink) { return; }
  fetch('/santa/confirm_email?token=' + encodeURIComponent(confirmLink), { credentials: 'same-origin', cache: 'no-store' })
    .then((r) => (r.ok ? r.json() : null))
    .then((d) => {
      if (!d || !d.ok) { return; }
      document.querySelectorAll('#child_name').forEach((el) => { el.value = d.child_name || ''; });
      if (email) { email.value = d.email || ''; }
      document.getElementById('form_ordering_email').value = d.email || '';
      document.getElementById('discountEmail').value = d.email || '';
      if (d.fbc && !getCookie('_fbc')) {
        document.cookie = '_fbc=' + d.fbc + '; path=/; max-age=7776000; SameSite=Lax';
      }
      trackStep('confirm_landing');
      if (d.paid) {
        document.getElementById('gate-title').textContent = '✨ ' + childOr('Your child') + " is on Santa's good list! ✨";
        document.getElementById('gate-waiting').classList.add('hidden');
        document.getElementById('gate-done').classList.remove('hidden');
        replaceDiv(openingStep(), 'step-3');
        return;
      }
      document.getElementById('order_id').innerHTML = d.order_id;
      showPayment(openingStep());
    })
    .catch((err) => console.log('confirm link: ' + err));
}
startConfirmLink();
